module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-logo-text"
  }, [_vm._v(" MAKEPEACE WITH CHESS")])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger",
    class: {
      'is-active': _vm.showLinksMenu
    },
    on: {
      "click": function($event) {
        _vm.toggleBurger()
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.showLinksMenu
    }
  }, [_c('div', {
    staticClass: "navbar-start"
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleBurger()
      }
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/phil"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleBurger()
      }
    }
  }, [_vm._v("About Phil")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/services"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleBurger()
      }
    }
  }, [_vm._v("Services")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/contact"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleBurger()
      }
    }
  }, [_vm._v("Contact")])], 1)])])]), _vm._v(" "), (_vm.$route.path == '/') ? _c('section', {
    staticClass: "hero is-dark is-fullwidth"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section main"
  }, [_c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "footer mpwc-footer"
  }, [_vm._m(1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "content has-text-centered sticky-bottom"
  }, [_c('p', {
    staticClass: "is-size-7"
  }, [_c('span', [_vm._v("© 2018-" + _vm._s(new Date().getFullYear()) + " Makepeace With Chess Ltd.")]), _vm._v(" "), _c('span', [_vm._v("All rights reserved.")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "logo-banner"
  }, [_c('h1', {
    staticClass: "title logo-text is-marginless is-paddingless"
  }, [_vm._v("MAKEPEACE"), _c('br'), _vm._v("WITH CHESS")]), _vm._v(" "), _c('img', {
    staticClass: "logo is-marginless is-paddingless",
    attrs: {
      "src": require("./assets/logo-white.svg")
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Professional chess coaching in London")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_c('ul', {
    staticClass: "chess-list"
  }, [_c('li', [_vm._v("Chess clubs in schools")]), _vm._v(" "), _c('li', [_vm._v("One-to-one coaching")]), _vm._v(" "), _c('li', [_vm._v("Online courses")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "logo-banner"
  }, [_c('h1', {
    staticClass: "title logo-text is-marginless is-paddingless"
  }, [_vm._v("MAKEPEACE"), _c('br'), _vm._v("WITH CHESS")]), _vm._v(" "), _c('img', {
    staticClass: "logo is-marginless is-paddingless",
    attrs: {
      "src": require("./assets/logo.svg")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Professional chess coaching in London")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:makepeacewithchess@gmail.com"
    }
  }, [_vm._v("makepeacewithchess@gmail.com")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "button"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://twitter.com/ChessCoaches",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "http://makepeacewithchess.com/contact"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('a', {
    staticClass: "twitter-timeline",
    attrs: {
      "data-height": "360",
      "href": "https://twitter.com/ChessCoaches"
    }
  }, [_vm._v("Tweets by ChessCoaches")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87f31ae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 40
// module chunks = 0